class ApiIntegrationCreateForm{
    constructor(tableId) {
        this.tableId = tableId;
        this.init();
        this.validation();
    }
    init() {
        const ipAddressInput = document.querySelector('#'+this.tableId+' input[name=ip_addresses]');
        if(ipAddressInput){
            let tg = new Tagify(ipAddressInput, {
                transformTag: function(tagData) {
                    tagData.value = tagData.value.toLowerCase()
                    ;
                    return;
                },
                keepInvalidTags: false,
                editTags: 10,
                pattern: /^([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(?<!172\.(16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31))(?<!127)(?<!^10)(?<!^0)\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(?<!192\.168)(?<!172\.(16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31))\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm,
                delimiters: ",|;| ,| |:|[\\\r]",
                maxTags: 10,
            });
            new SpacebarEvent(tg);
        }

        const picker = new tempusDominus.TempusDominus(document.getElementById("createApiIntegrationDatePicker"), {
            restrictions: {
                minDate: moment().toDate(),
                maxDate: moment().add(6, 'months').toDate()
            },
            display: {
                viewMode: "calendar",
                components: {
                    clock: false
                }
            },
            localization: {
                startOfTheWeek: 1
            }
        });

        $('#createApiIntegrationDatePicker').on('changeDate', function(ev){
            $(this).datepicker('hide');
        });
        picker.dates.formatInput = date => moment(date).format('YYYY-MM-DD');
        picker.dates.setValue(tempusDominus.DateTime.convert(moment().add(3, 'months').toDate()));

        $('#create-api-integration-rotate-token').click(function(){
            $.ajax({
                url: url.href+'?do=getNewToken',
                type: 'POST',
                dataType: ''
            }).done(function (data) {
                $('#frm-createApiIntegrationForm-createApiIntegration input[name=token]').val(data.token);
            });
        });
        $('#unlimited_expiration_check').change(function(){
            $('#expiration_date_picker_input').slideToggle();
        });
        this.clipboard();


    }

    validation(){
        let form = document.getElementById('frm-createApiIntegrationForm-createApiIntegration');
        if(!form){
            form = document.getElementById('frm-createAccountTokenForm-createApiIntegration');
        }

        if(form){
            let submitButton = document.getElementById('create_integration_submit_button');
            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                        'expiration': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                        'token': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'token' || e.element.attributes.name.value === 'expiration'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }

    }
    clipboard(){
        const target = document.getElementById('create-api-integration-copy-token');
        let clipboard = new ClipboardJS(target, {
            container: document.getElementById('create_api_integration_modal'),
            target: target,
            text: function () {
                var token = $('#frm-createApiIntegrationForm-createApiIntegration input[name=token]').val();

                if(token !== undefined){
                    return token;
                }
                return $('#frm-createAccountTokenForm-createApiIntegration input[name=token]').val();
            }
        });

        clipboard.on('success', function (e) {
            const currentLabel = target.innerHTML;
            if (target.innerHTML === 'Copied!') {
                return;
            }
            // Update button label
            target.innerHTML = 'Copied!';
            // Revert button label after 3 seconds
            setTimeout(function () {
                target.innerHTML = currentLabel;
                }, 3000);
        });
    }
}
window.ApiIntegrationCreateForm = ApiIntegrationCreateForm;